import React from 'react';
import Img from 'gatsby-image';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { Container } from '../../UI/Container/Container';
import { Grid, GridRow, GridCol } from '../../UI/Grid';
import { VisualImages } from './types';

const TwoImages: React.StatelessComponent<VisualImages> = ({ images }) => (
    <Container size="md" className="Visual-twoImages">
        <Grid>
            <GridRow horizontalAlign={'h-start'} verticalAlign={'v-center'}>
                {images[0].visual_image.localFile &&
                    images[0].visual_image.localFile.childImageSharp && (
                        <GridCol colSize={`6`} mobileColSize={`12`}>
                            <Img
                                sizes={images[0].visual_image.localFile.childImageSharp.sizes}
                                alt={images[0].visual_image_atl.text || ''}
                            />
                            {images[0].visual_image_description.html && (
                                <PrismicHTMLParser className="Visual-twoImagesDescription">
                                    {images[0].visual_image_description.html}
                                </PrismicHTMLParser>
                            )}
                        </GridCol>
                    )}
                {images[1].visual_image.localFile &&
                    images[1].visual_image.localFile.childImageSharp && (
                        <GridCol colSize={`6`} mobileColSize={`12`}>
                            <Img
                                sizes={images[1].visual_image.localFile.childImageSharp.sizes}
                                alt={images[1].visual_image_atl.text || ''}
                            />
                            {images[1].visual_image_description.html && (
                                <PrismicHTMLParser className="Visual-twoImagesDescription">
                                    {images[1].visual_image_description.html}
                                </PrismicHTMLParser>
                            )}
                        </GridCol>
                    )}
            </GridRow>
        </Grid>
    </Container>
);

export default TwoImages;
